import { render, staticRenderFns } from "./WorkshopGroupDetail.vue?vue&type=template&id=23828272&scoped=true&"
import script from "./WorkshopGroupDetail.vue?vue&type=script&lang=js&"
export * from "./WorkshopGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopGroupDetail.vue?vue&type=style&index=0&id=23828272&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23828272",
  null
  
)

export default component.exports